import { BaseApi } from './baseApi';

export class CollectionsApi extends BaseApi {
    list(workspaceId, params) {
        return this.get([`/workspaces/${workspaceId}/collections`, params]);
    }
}

export default new CollectionsApi();
